'use client'
import React, { useEffect } from 'react'
import { ApolloProvider } from '@apollo/client/react'
import { useRouter } from 'next/navigation'
import { SnackbarProvider } from 'notistack'
import { useAtom } from 'jotai'

import { ManagerLayout } from '@docpace/manager-react-components/ManagerLayout'
import { apolloClient, serverHostname } from '@docpace/apps/manager-app/client'
import { useSessionSharing } from '@docpace/shared-react-hooks/useSessionSharing'
import { useIsChangingRoute } from '@docpace/shared-react-hooks/useIsChangingRoute'
import { ctxApiServerHostname } from '@docpace/shared-react-atoms'
import managerRoutes from '@docpace/shared-react-routes/managerRoutes'

export default function ManagerLayoutClientComponent({
    // Layouts must accept a children prop.
    // This will be populated with nested layouts or pages
    children,
}: {
    children: React.ReactNode
}) {
    useIsChangingRoute()
    const router = useRouter()
    const { isInitialized } = useSessionSharing({
        // another tab signed out — drop cached data and leave authed pages
        onSessionCleared: async () => {
            try {
                await apolloClient.clearStore()
            } catch (e) {}
            router.replace(managerRoutes.Signin.hrefNext())
        },
    })
    const [, setApiServerHostname] = useAtom(ctxApiServerHostname)
    useEffect(() => {
        setApiServerHostname(serverHostname)
    }, [])

    return (
        <ApolloProvider client={apolloClient}>
            <SnackbarProvider
                maxSnack={8}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
            >
                {isInitialized && <ManagerLayout>{children}</ManagerLayout>}
            </SnackbarProvider>
        </ApolloProvider>
    )
}
